// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"84c966e5","453":"fcfdc848","455":"1a4b87e1","952":"4d348d12","977":"b7477d23"}[chunkId] + ".chunk.js";
};